import { render, staticRenderFns } from "./SettingsPrivacy.vue?vue&type=template&id=144f67ce&scoped=true&"
import script from "./SettingsPrivacy.vue?vue&type=script&lang=js&"
export * from "./SettingsPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPrivacy.vue?vue&type=style&index=0&id=144f67ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144f67ce",
  null
  
)

export default component.exports